import Vue from 'vue'

import 'normalize.css'
import ElementUI from 'element-ui'
import SvgIcon from 'vue-svgicon'

import '@/styles/element-variables.scss'
import '@/styles/index.scss'

import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import '@/icons/components'
import '@/permission'
import filter from "@/utils/filter"

import areaAllApis from "@/api/area"

Vue.filter('formatDate', filter.formatDate)
Vue.filter('formatYearMonthDayDate', filter.formatYearMonthDayDate)
Vue.filter('currency', filter.currency)
Vue.filter('number_format', filter.number_format)
Vue.filter('formatMobilePhone',filter.formatMobilePhone)
Vue.prototype.$uploadUrl = process.env.VUE_APP_BASE_API + '/api/services/app/Client/Upload?id=2'
Vue.prototype.$abpApi = areaAllApis;
Vue.prototype.baseURL = process.env.VUE_APP_BASE_API;

Vue.use(ElementUI)
Vue.use(SvgIcon, {
  tagName: 'svg-icon',
  defaultWidth: '1em',
  defaultHeight: '1em'
});

const eventBus = new Vue();
(window as any).$eventBus = eventBus;
Vue.prototype.$bus = eventBus;

// 获取年月
Vue.prototype.$getCaption = function (obj: string, state: number = 0) {
  var index = obj.lastIndexOf("\-");
  if (state === 0) {
    obj = obj.substring(0, index);
  } else {
    obj = obj.substring(index + 1, obj.length);
  }
  return obj;
}

Vue.directive('permission',{
  bind:(el,binding,vnode)=>{
    const permissionName = binding.value;
    const permissions = store.state.user.permissions;
    if(!hasPermission(permissionName)){
      el.style.display = 'none';
    }

  },
  update(el,binding,vnode){
    const permissionName = binding.value;
    if(!hasPermission(permissionName)){
      el.style.display = 'none';
    } else {
      el.style.display = '';
    }
  }
})

function hasPermission(permissionName:string) :boolean{
  const permissions = store.state.user.permissions;
  // console.log(`permissionName:${permissionName}`,permissions);
  if(!(permissions
    && permissions instanceof Array
    && permissions.length
    && permissions.some(name=>name === permissionName))){
    return false;
  } else {
    return true;
  }
}


Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
